import { get, save, create, remove } from './http';
import { fakeIt, asPromise } from '../../components/utils/api';

/**
 * Mocking client-server processing
 */

const _part_result = {
    "url": "/components/part.php?loggedin=1"
};

const _variants = [
    {
        'Price': 107.18,
        'Condition': 'New CAT',
        'Available': 2
    },
    {
        'Price': 75.99,
        'Condition': 'AB',
        'Available': 4
    },
    {
        'Price': 92.32,
        'Condition': 'U',
        'Available': 1
    }
];

const _variants_guest = [
    {
        'Price': 0,
        'Condition': 'New CAT',
        'Available': 2
    },
    {
        'Price': 0,
        'Condition': 'AB',
        'Available': 4
    },
    {
        'Price': 0,
        'Condition': 'U',
        'Available': 1
    }
];

// export function getPartResult({query}){
//     return get(`partResult`,{query});
// }

// export function getVariants(PartNumber){
//     //return fakeIt([]);
//     // return fakeIt(_variants);
//     // return fakeIt(_variants_guest);
//     return get(`partVariants`,{PartNumber});
// }

export function createConcierge(fields){
    //return fakeIt(_part);
    return create(`concierge`,fields);
}

export function createExtended(fields){
    //return fakeIt(_part);
    return create(`extended`,fields);
}